import "./ComponentStyles/About.css";
import PersonInfoBox from "./PersonInfoBox";

function About(props) {
  return (
    <div id="about">
        <div id="about-text">
          <div id="who-are-we">
            <h1>
              Who we are
            </h1>
            <div>
              We are a collaborative community of STEM and non-STEM students! We focus on developing valuable technical skills within our members.
            </div>
          </div>
          <div id="information">
            <div id="membership">
              <h1>
                Membership Requirements
              </h1>
              <div>
                NONE. (except your interest!) <br/> <br/>
                You do NOT need to be an electrical engineer, NOR have any technical experience to get involved!
              </div>
            </div>
            <div id="lab-info">
              <h1>
                Lab Information
              </h1>
              <div>
                ITE 244 <br/> <br/>
                Hours TBD
              </div>
            </div>
          </div>
        </div>
        <PersonInfoBox role="President" orientation="left"></PersonInfoBox>
        <PersonInfoBox role="Vice-President" orientation="right"></PersonInfoBox>
        <PersonInfoBox role="Treasurer" orientation="left"></PersonInfoBox>
        <PersonInfoBox role="Secretary" orientation="right"></PersonInfoBox>
        <PersonInfoBox role="Lab-Director" orientation="left"></PersonInfoBox>
        <PersonInfoBox role="Historian" orientation="right"></PersonInfoBox>
    </div>
  );
}

export default About;